/** Something thrown that isn't an `Error` (a string, an object), wrapped so it can be shown and reported. */
export class NonErrorThrown extends Error {
  readonly _tag = "NonErrorThrown";
  constructor(readonly thrown: unknown) {
    super(typeof thrown === "string" ? thrown : "A non-error value was thrown");
    this.name = "NonErrorThrown";
  }
}

/** Route errors arrive as `unknown`: anything can be thrown. */
export function asError(thrown: unknown): Error {
  return thrown instanceof Error ? thrown : new NonErrorThrown(thrown);
}
